import Template from 'ln/template/TemplateManager';
import Node from 'ln/node/Node';
import View from 'ln/view/View';
import UserCourseModel from '../course/models/UserCourseModel';
import setup from 'ln/setup/setup';
import { scanner } from 'ln/view/Scanner';
import CourseElementModel from '../course/models/CourseElementModel';

/*
 * Main class for showing processplan as print version
 */
class Processplan extends View {
	
	private userCourse:UserCourseModel;

	private materials:boolean = false;
	private instructions:boolean = false;
	private objectives:boolean = false;
	private expertises:boolean = false;
	private showEndbehaviour:boolean = false;

	private materialFilterBtn;
	private instructionFilterBtn;
	private objectiveFilterBtn;
	private expertiseFilterBtn;

	
	constructor(){
		
		super( setup.data( 'course' ) );

		this.userCourse = setup.data( 'course' );
		this.userCourse.set( 'template', 'krw.processplan' );

		this.showEndbehaviour = setup.data( 'ppConfig' ).showEndbehaviour;

	}

	/**
	 * @overwrite
	 */
	public init() {
		
		this.userCourse.sequences.all().forEach( ( courseElement:CourseElementModel, i:number, courseElements:CourseElementModel[] ) => {
			
			var name = courseElement.modelName.replace( 'App\\', '' ).toLowerCase();
			var courseElementView = Node.fromHTML( Template.render( 'krw.pp_' + name, courseElement ) );
			
			// set the time for each course-element
			if( courseElement.modelName != 'App\\Daybreak' ){
				courseElementView.js( 'display-time' ).html = courseElements[i-1].endTime() + ' - ' + courseElement.endTime();
			}
	
			this.node.js( 'pp_courseelements' ).append( courseElementView );

		});

		this.materialFilterBtn = Node.js( 'material-filter' )
		this.instructionFilterBtn = Node.js( 'instruction-filter' )
		this.objectiveFilterBtn = Node.js( 'objective-filter' )
		this.expertiseFilterBtn = Node.js( 'expertise-filter' )

		if( this.materialFilterBtn ) this.materialFilterBtn.click.add( this.toggleMaterials, this );
		if( this.instructionFilterBtn ) this.instructionFilterBtn.click.add( this.toggleInstructions, this );
		if( this.objectiveFilterBtn ) this.objectiveFilterBtn.click.add( this.toggleObjectives, this );
		if( this.expertiseFilterBtn ) this.expertiseFilterBtn.click.add( this.toggleExpertises, this );

		// toggle materials or instructions if needed
		if( setup.data( 'ppConfig' ).showMaterials ) this.toggleMaterials();
		if( setup.data( 'ppConfig' ).showInstructions ) this.toggleInstructions();
		if( setup.data( 'ppConfig' ).showObjectives ) this.toggleObjectives();
		if( setup.data( 'ppConfig' ).showExpertises ) this.toggleExpertises();

		// hide endbehaviour if needed
		this.toggleRows( '.endbehaviour-row', !this.showEndbehaviour );
		
	}

	private toggleMaterials(){

		if( this.materialFilterBtn ){
			this.toggleBtn( this.materialFilterBtn );
			this.toggleRows( '.material-row', this.materials );
			this.toggleUrlParam( 'materials', this.materials );
			this.materials = !this.materials;
		}
	}
	
	private toggleInstructions(){

		if( this.instructionFilterBtn ){
			this.toggleBtn( this.instructionFilterBtn );
			this.toggleRows( '.instruction-row', this.instructions );
			this.toggleUrlParam( 'instructions', this.instructions );
			this.instructions = !this.instructions;

		}
	}

	private toggleObjectives(){
		if( this.objectiveFilterBtn ){
			this.toggleBtn( this.objectiveFilterBtn );
			this.toggleRows( '.objective-row', this.objectives );
			this.toggleUrlParam( 'objectives', this.objectives );
			this.objectives = !this.objectives;
		}
	}

	private toggleExpertises(){
		if( this.expertiseFilterBtn ){
			this.toggleBtn( this.expertiseFilterBtn );
			this.toggleRows( '.expertise-row', this.expertises );
			this.toggleUrlParam( 'expertises', this.expertises );
			this.expertises = !this.expertises;
		}
	}
	
	private toggleRows( classname:string, force:boolean ){
		this.node.all( classname ).forEach( row => {
			row.toggleClass( '-hidden', force );
		});
	}

	private toggleBtn( btn:Node ){
		btn.native.blur();
		btn.toggleClass( 'active' );
	}
	
	private toggleUrlParam( param:string, state:boolean ){
		
		let downloadBtn = Node.js( 'download' );
		var url = downloadBtn.getAttribute( 'href' );
		
		let regex = new RegExp( param + '[^\/]+', 'gm' );
		let subst = ( state ) ? param + 'false' : param + 'true';
		downloadBtn.setAttribute( 'href', url.replace( regex, subst ) );

	}
	
	/**
	 * @overwrite
	 */
	protected renderData(){
		return this.userCourse;
	}

}

export default Processplan;

scanner.ioc.add( 'processplan', function( node ){
	return new Processplan().render( node );
});